export type QueryPaginationMeta = {
    limit: number;
    offset: number;
    wishlistId?: number;
    orderBy?: string;
};

export enum WISHLIST_ITEMS_SORTING_TYPE {
    recentlyAdded = "recentlyAdded",
    aToZProductTitle = "aToZProductTitle",
    zToAProductTitle = "zToAProductTitle",
    highToLowPrice = "highToLowPrice",
    lowToHighPrice = "lowToHighPrice",
}

export enum WISHLIST_ITEMS_FILTERING_TYPE {
    all = "all",
    available = "available",
}

export enum WISHLIST_BRANDING_LAUNCHER_VISIBILITY_TYPES {
    allDevices = "allDevices",
    desktopOnly = "desktopOnly",
    mobileOnly = "mobileOnly",
    hide = "hide",
}
